export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6915.f746e4ec.jpg";